module.exports = __webpack_public_path__ + "img/sest-6-sel.9c0793a5.svg";